import React from 'react';
import { useAuth, RedirectToSignIn } from '@clerk/clerk-react';
import DashboardSettings from './DashboardSettings';

const ProtectedRoute = () => {
  const { isLoaded, isSignedIn } = useAuth();
  
  // Check if we're on preview domain (use fallback)
  const isPreviewDomain = window.location.hostname.includes('preview.emergentagent.com');
  
  // For preview domains, always show dashboard directly
  if (isPreviewDomain) {
    return <DashboardSettings />;
  }
  
  // For production domains, show dashboard if signed in
  if (isLoaded && isSignedIn) {
    return <DashboardSettings />;
  }
  
  // For production domains, redirect to sign in (no loading state)
  // This will redirect immediately, letting Clerk handle the loading
  return <RedirectToSignIn />;
};

export default ProtectedRoute;